export default {"src":"/_next/static/media/plane.58a06d6c.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};